import { Check } from 'lib/utils/formValidation/formValidation';
import isEmpty from 'lib/utils/formValidation/isEmpty';

const isRequired: Check = (value) => !isEmpty(value);

export default isRequired;
